<div class="user-login-container">
    <form [formGroup]="loginForm" (submit)="onVendorLoginSubmit(loginForm)">
        <h4>Florist Login</h4>
        <div class="row white-box">
            <div class="col-md-12">
                <label>Email</label>
                <mat-form-field appearance="outline" floatLabel="never">
                    <input type="text" formControlName="email" matInput placeholder="Enter Email" required />
                    <mat-error *ngIf="requiredValidation(formControls['email'])">Email is required</mat-error>
                    <mat-error *ngIf="patternValidation(formControls['email'])">Enter valid email address</mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-12" floatLabel="never">
                <label>Password</label>
                <mat-form-field appearance="outline">
                    <input type="password" formControlName="password" matInput placeholder="Enter Password" required />
                    <mat-error *ngIf="requiredValidation(formControls['password'])">Password is required</mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6 MB-10">
                <button type="submit" [disabled]="!loginForm.valid" mat-raised-button class="black-btn" color="primary">
                    LOGIN
                </button>
            </div>

            <div class="col-md-6 text-right">
                <a [routerLink]="panditForgotUrl">Forgot Password?</a>
            </div>

            <div class="col-md-12">
                <app-social-logins [userType]="'florist'"></app-social-logins>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 text-center sign-up-link">
                <span>Don't have an account? <a [routerLink]="signupUrl">Create Account</a></span>
            </div>
        </div>
    </form>
</div>